import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import { BootstrapAlert } from "../../components/BootstrapAlert";

// services
import {
  useGetTrainingMenuBasedOnModuleQuery,
  useBookmarkModuleMutation,
  useUpdateModuleStatusMutation,
} from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);
  const navigate = useNavigate();

  /* Start useState */

  const [skipGetTrainingMenu, setSkipGetTrainingMenu] = useState(false);

  /* End useState */

  const { isLoading: isMenuFetched } = useGetTrainingMenuBasedOnModuleQuery(2, {
    skip: skipGetTrainingMenu,
  });

  const [
    updateModuleStatus,
    {
      isLoading,
      status: updateStatus,
      error: { data: { message: errorMessage } = {} } = {},
    },
  ] = useUpdateModuleStatusMutation();

  const [bookmarkModule, { status: bookmarkStatus }] =
    useBookmarkModuleMutation();

  if (bookmarkStatus === "fulfilled") {
    navigate("/module-2/indications");
  }
  /* Start useEffect */

  useEffect(() => {
    if (updateStatus === "fulfilled") {
      bookmarkModule({ pathName });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateStatus]); // * onUpdateMenu Status
  /* End useEffect */

  /* Start custom function */
  const handleStartModuleTwo = () => {
    setSkipGetTrainingMenu(true);
    updateModuleStatus({ moduleNo: 2, start: 1 });
  };

  return (
    <div className="row">
      {isMenuFetched && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <div className="col-sm-8">
        <div className="module-content">
          <h1 className="blue text-uppercase b mt-5 mb-4">MODULE 2 OVERVIEW</h1>
          <p className="d-inline me-4 b">1 hour</p>
          <p className="d-inline me-4 b">English</p>
          <p className="d-inline me-4 b">MIM Referring Required</p>
          <h2 className="b text-uppercase mt-4">
            <span className="orange">Learn the key anatomy,</span> steps, and
            Interpretation Criteria <br />
            for Amyvid PET images
          </h2>
          <article className="mt-5">
            <h3 className="b mb-3">In this module</h3>
            <ul>
              <li>Indication and Limitations of Use</li>
              <li>Important Safety Information</li>
              <li>Chapter 1: Review of Neuroanatomy</li>
              <li>Chapter 2: The 5 Steps of Reading Amyvid PET Scans</li>
              <li>Chapter 3: Demonstration Cases</li>
              <li>
                Chapter 4: Semi-Independent Learning Through Practice Cases
              </li>
            </ul>
          </article>
          <article className="mt-5 mb-5">
            <h3 className="b mb-3">Key learning</h3>
            <ul>
              <li>
                Learn and practice the 5 steps that should be followed for
                accurate interpretation of Amyvid PET images
              </li>
              <li>
                Understand the criteria for positive and negative Amyvid scans
              </li>
              <li>
                Recognize the most common risks and challenges for Amyvid scan
                misinterpretation
              </li>
              <li>
                Review 5 demonstration cases, including both positive and
                negative scans, as well as scans demonstrating the challenges of
                low contrast, image noise, and atrophy
              </li>
              <li>
                Use the MIM Referring with 7 practice cases for semi-independent
                learning on how to interpret Amyvid PET scans
              </li>
            </ul>
            <small className="fz-sm">PET=positron emission tomography.</small>
          </article>
          <section className="button-control">
            <BootstrapAlert variant="danger" message={errorMessage} />
            <LdsButton
              className="blue-button mt-3 mb-5 next"
              disabled={isLoading}
              onClick={handleStartModuleTwo}
            >
              Start Module 2
            </LdsButton>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Module_1_0;
